<div class="container">
  <div class="card">
    <h1>Create Account</h1>
    <p class="subtitle">
      Sign up for a Spectyra account. Our <strong>SDK for apps</strong> — so you can embed token and cost optimization and save on LLM API usage — is coming soon.
      Create an account now and we’ll notify you when it’s ready. (Using <strong>OpenClaw</strong>? Install the <a href="https://clawhub.ai/immrlucky/spectyra" target="_blank" rel="noopener noreferrer">local companion skill</a> — no account required for local savings.)
    </p>
    
    <form (ngSubmit)="register()" *ngIf="!success">
      <div class="form-group">
        <label for="email">Email</label>
        <input
          type="email"
          id="email"
          [(ngModel)]="email"
          [disabled]="loading"
          required
          placeholder="you@example.com"
          class="form-input">
      </div>
      
      <div class="form-group">
        <label for="password">Password</label>
        <input
          type="password"
          id="password"
          [(ngModel)]="password"
          [disabled]="loading"
          required
          placeholder="••••••••"
          minlength="8"
          class="form-input">
        <div class="help-text">Password must be at least 8 characters</div>
      </div>
      
      <div class="form-group">
        <label for="orgName">Workspace / organization name (optional)</label>
        <input
          type="text"
          id="orgName"
          [(ngModel)]="orgName"
          [disabled]="loading"
          placeholder="Leave blank to use a default from your email"
          class="form-input">
      </div>
      
      <div class="form-group">
        <label for="projectName">Project Name (Optional)</label>
        <input
          type="text"
          id="projectName"
          [(ngModel)]="projectName"
          [disabled]="loading"
          placeholder="Default Project"
          class="form-input">
      </div>
      
      <button type="submit" class="btn btn-primary" [disabled]="loading || !email || !password">
        {{ loading ? 'Creating Account...' : 'Create Account' }}
      </button>
    </form>
    
    <div *ngIf="success && apiKey" class="success-box">
      <h2>🎉 Account Created!</h2>
      <p>Your API key has been generated. <strong>Save it now</strong> - you won't be able to see it again!</p>
      
      <div class="api-key-box">
        <code>{{ apiKey }}</code>
        <button class="btn btn-secondary" (click)="copyApiKey()">Copy</button>
      </div>
      
      <div class="sdk-notice">
        <p>
          You’re set up for Spectyra Cloud. We’ll use this email to <strong>notify you</strong> about the SDK and product updates.
          Your API key below is for upcoming cloud features and integrations.
        </p>
      </div>
      
      <button class="btn btn-primary" (click)="goToApp()">Continue to App</button>
    </div>
    
    <div *ngIf="successMessage" class="success-banner">
      <p>{{ successMessage }}</p>
    </div>

    <div *ngIf="error" class="error-box">
      <p>{{ error }}</p>
    </div>
    
    <div class="login-link">
      Already have an account? <a [routerLink]="['/login']" [queryParams]="{ returnUrl: route.snapshot.queryParams['returnUrl'] }">Login</a>
    </div>
  </div>
</div>
